<nz-spin [nzSpinning]="loading">
    <nz-cascader
        [disabled]="disabled"
        [nzExpandTrigger]="'hover'"
        [nzOptions]="locationOptions"
        [(ngModel)]="values"
        [nzChangeOnSelect]="true"
    ></nz-cascader>
</nz-spin>
